/**
 * Who may change organization-wide configuration (integrations, org reports,
 * report templates): admins and owners of the tenant, and platform admins.
 * Case-insensitive so a role stored as "Admin" is never demoted.
 */
export function canAdministerOrg(user?: { role?: string | null; isPlatformUser?: boolean } | null): boolean {
  if (!user) return false;
  if (user.isPlatformUser) return true;
  const role = (user.role || '').toLowerCase();
  return role === 'admin' || role === 'owner';
}

/**
 * Report tabs and report-builder sources whose figures are organization-wide
 * rather than narrowed to the viewer, so an agent's "My Data" view must not
 * offer them.
 */
export const ORG_WIDE_REPORT_IDS = new Set(['agents', 'teams', 'ai', 'automations', 'pipelines', 'custom-metrics']);
export const ORG_WIDE_DATA_SOURCES = new Set(['agents', 'automations', 'pipelines', 'custom_metrics']);

/** Report templates meant for leadership or for comparing agents. */
export function isOrgWideTemplate(template: { id?: string; name?: string; data_source?: string }): boolean {
  if (template.data_source && ORG_WIDE_DATA_SOURCES.has(template.data_source)) return true;
  return /exec|leadership|scorecard/i.test(`${template.id ?? ''} ${template.name ?? ''}`);
}
